import React from 'react'
import { Button, Modal } from '../../components'

export const ResponseSentModal = ({
  title,
  body,
  onHide,
  titleAlign,
  ...rest
}) => (
  <Modal onHide={onHide} size={'xm'} {...rest}>
    <Modal.Header closeButton>
      <Modal.Title align={titleAlign}>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{body}</Modal.Body>
    <Modal.Footer align="center">
      <Button
        text="Ir para o dashboard"
        width="200px"
        variant="outlined"
        onClick={() => onHide?.(false)}
      />
    </Modal.Footer>
  </Modal>
)
